import { render, staticRenderFns } from "./IdentificationTable.vue?vue&type=template&id=63c5c0b0&scoped=true&"
import script from "./IdentificationTable.vue?vue&type=script&lang=js&"
export * from "./IdentificationTable.vue?vue&type=script&lang=js&"
import style0 from "./IdentificationTable.vue?vue&type=style&index=0&id=63c5c0b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c5c0b0",
  null
  
)

export default component.exports